import { useGetPath } from '@hooks/interview/useGetPath';
import { useCondition } from '@hooks/utils/useCondition';
import { type PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

const IntervieweeAuthenticatedLayout = ({ children }: PropsWithChildren) => {
  const { rootPath } = useGetPath();
  const { isUserLoggedIn, hasMeetingCondition } = useCondition();

  if (!isUserLoggedIn && hasMeetingCondition)
    return <Navigate to={rootPath.SETTING} replace />;

  if (!isUserLoggedIn && !hasMeetingCondition)
    return <Navigate to={rootPath.HOME} replace />;

  return <>{children}</>;
};

export default IntervieweeAuthenticatedLayout;
